export default "__VITE_ASSET__BHWonPT6__"